// Mock data for Legacy & Landscapes glamping website

export const heroData = {
  title: "Your Land is More Than Acres",
  subtitle: "It's an Experience Waiting to Be Heard",
  description: "Most landowners are sitting on a 'silent asset'—beautiful corners of their property that offer peace but generate no value. We provide the Glamping units and open the channel to an income stream from that beauty",
  cta: "Request a Site Discovery Walk",
  image: "https://customer-assets.emergentagent.com/job_impact-zones/artifacts/4l2bzakn_62e43250-350d-418b-bc3d-db894b89fa8d.jfif"
};

export const legacyData = {
  title: "Your Legacy",
  subtitle: "Sweat the Asset, Spare the Soil",
  description: "Turn rocky outcrops, riverbanks, or ridgelines into the most profitable per-square-meter acreage on the farm without scarring the earth.",
  stats: [
    {
      id: "stat-land-footprint",
      value: "1%",
      label: "Land Footprint Required",
      description: "Use 1% of your land to fund estate maintenance, taxes, and security"
    },
    {
      id: "stat-return-nature",
      value: "30 Days",
      label: "Return to Nature",
      description: "No impact adjustable leg foundations mean the land can return to its natural state if structures are moved"
    },
    {
      id: "stat-family-legacy",
      value: "Multi-Gen",
      label: "Family Legacy",
      description: "Create a revenue engine ensuring the property remains in the family for generations"
    }
  ],
  features: [
    { id: "feat-1", text: "Touch the earth lightly with removable no impact adjustable leg foundations" },
    { id: "feat-2", text: "Turn 'waste land' into your most profitable acreage" },
    { id: "feat-3", text: "Fund estate operations through beauty, not development" },
    { id: "feat-4", text: "Preserve indigenous flora and natural water features" }
  ],
  image: "https://images.unsplash.com/photo-1484318571209-661cf29a69c3"
};

export const opportunityData = {
  title: "The Opportunity",
  subtitle: "The 'Goldilocks' Window for Luxury Glamping",
  marketStats: {
    marketSize: "Billions of Rands",
    growthRate: "10.1%",
    nicheGrowth: "11.5%",
    year: "2030"
  },
  demographics: {
    ageRange: "33-60 years",
    profile: "Tech-savvy, high-earning professionals",
    spending: "25% of global travel spending",
    preference: "Off-the-beaten-track authenticity"
  },
  financials: {
    revenuePerUnit: "Revenue > R600K pa",
    projectedROI: "Infinate",
    peakRate: "R5000 to R6500",
    occupancyTarget: "70%"
  },
  trends: [
    {
      id: "trend-disconnection",
      period: "2025-2027",
      phase: "The Disconnection Phase",
      demand: "Massive demand for 'Silent Stays' and 'Digital Detox' locations"
    },
    {
      id: "trend-branded",
      period: "2028-2030",
      phase: "The Branded Experience",
      demand: "Travelers seek specific architectural icons as sculptural landmarks"
    }
  ],
  image: "https://images.unsplash.com/photo-1520513455472-b259f1ec720a"
};

export const sanctuaryData = {
  title: "The Sanctuary",
  subtitle: "Architectural Elegance Meets Zero-Impact Engineering",
  description: "Sculptural pods with aerodynamic, organic curves that mimic natural outcroppings or river stones",
  specifications: [
    {
      id: "spec-thermal",
      category: "Thermal & Acoustic Mastery",
      details: "Multi-layered membranes maintain 21°C-23°C year-round and dampen all external noise"
    },
    {
      id: "spec-offgrid",
      category: "Off-Grid Autonomy",
      details: "Integrated solar, lithium-ion storage, and odorless bio-digesters for zero-impact waste"
    },
    {
      id: "spec-biomimicry",
      category: "Biomimicry Design",
      details: "Soft, parabolic silhouettes blend into the landscape rather than competing with it"
    },
    {
      id: "spec-materials",
      category: "Premium Materials",
      details: "from R500 000 architectural masterpiece of canvas, timber, and glass"
    }
  ],
  experience: {
    scent: "Wood-smoke from private hot tub and indigenous fynbos or forest air",
    sound: "Rhythmic flow of river or the silence of your valley",
    comfort: "600-thread-count cotton bedding in R5,000-per-night sanctuary"
  },
  images: [
    { id: "img-1", url: "https://customer-assets.emergentagent.com/job_impact-zones/artifacts/lh0rfq7p_f797a514-cde2-4156-ab67-3c5e6cf6c995.jfif" },
    { id: "img-2", url: "https://customer-assets.emergentagent.com/job_impact-zones/artifacts/orjhyn6s_4.jpg" },
    { id: "img-3", url: "https://customer-assets.emergentagent.com/job_impact-zones/artifacts/f9hbgm8m_82f57084-d302-45de-bed0-d0be5531a3ba.jfif" }
  ]
};

export const strategyData = {
  title: "The Strategy",
  subtitle: "The Curation Engine",
  description: "We don't build; we curate scarcity. We bypass the masses to target exclusivity.",
  approach: [
    {
      id: "approach-scarcity",
      title: "The Scarcity Model",
      description: "Limiting availability to fewer bespoke bookings per month creates a price floor and maintains high demand",
      icon: "target"
    },
    {
      id: "approach-distribution",
      title: "Exclusive Distribution",
      description: "Target 'Slow Travel' curators and wellness platforms where guests pay premium for under-the-radar locations",
      icon: "sparkles"
    },
    {
      id: "approach-content",
      title: "Content Magnet",
      description: "Instagrammable architecture generates 1M+ impressions from single high-end influencer stays",
      icon: "camera"
    },
    {
      id: "approach-audit",
      title: "The Pristine Audit",
      description: "Your bi-annual checks ensure indigenous flora and water tables remain untouched",
      icon: "leaf"
    }
  ],
  kpis: [
    { id: "kpi-yield", text: "Yield Per Hectare: Revenue comparison of 60sqm pod footprint vs other land uses" },
    { id: "kpi-audit", text: "Pristine Audit: Your bi-annual eco-structure impact assessment" },
    { id: "kpi-emotion", text: "Return on Emotion: Guest transformation feedback securing premium rates" }
  ],
  image: "https://images.unsplash.com/photo-1648326342761-8a9abfb7a2c0"
};

export const contactData = {
  title: "The Site Discovery Invitation",
  subtitle: "We Don't Ask for Commitment. We Ask for a Walk.",
  description: "We will walk your forest or riverfront with an AI-driven feasibility lens to identify your highest-yield 'Impact Zones'",
  leadMagnet: "Download: Digital Detox Executive Guide",
  formFields: [
    { id: "field-firstName", name: "firstName", label: "First Name", type: "text", required: true },
    { id: "field-lastName", name: "lastName", label: "Last Name", type: "text", required: true },
    { id: "field-email", name: "email", label: "Email Address", type: "email", required: true },
    { id: "field-phone", name: "phone", label: "Phone Number", type: "tel", required: false },
    { id: "field-location", name: "location", label: "Property Location", type: "text", required: false },
    { id: "field-propertySize", name: "propertySize", label: "Approximate Land Size (Hectares)", type: "text", required: false },
    { id: "field-message", name: "message", label: "Tell Us About Your Land & Vision", type: "textarea", placeholder: "E.g., river frontage, mountain views, forest, key features, etc.", required: false }
  ]
};

export const testimonials = [
  {
    id: "testimonial-mpumalanga",
    name: "",
    location: "Mpumalanga Estate Owner",
    quote: "Our river valley was beautiful 'dead space'. Now it generates more revenue per square meter than our entire operation.",
    rating: 5
  },
  {
    id: "testimonial-westerncape",
    name: "",
    location: "Western Cape Landowner",
    quote: "The pods are architectural masterpieces. Our guests book 6 months in advance, and we maintain complete privacy on the rest of our property.",
    rating: 5
  },
  {
    id: "testimonial-kzn",
    name: "",
    location: "KwaZulu-Natal Conservation Farm",
    quote: "Finally, a way to fund our conservation efforts without compromising the land. The pristine audit gives us peace of mind.",
    rating: 5
  }
];

export const footerData = {
  companyName: "Legacy & Landscapes",
  tagline: "Turning Pristine South African Soil into High-Yield Legacy",
  email: "steve@goglamping.co.za",
  phone: "+27 083 449 7722",
  address: "Knysna, Garden Route, South Africa",
  socialLinks: [
    { id: "social-instagram", platform: "instagram", url: "#" },
    { id: "social-linkedin", platform: "linkedin", url: "#" },
    { id: "social-facebook", platform: "facebook", url: "#" }
  ],
  quickLinks: [
    { id: "link-privacy", label: "Privacy Policy", url: "#" },
    { id: "link-terms", label: "Terms of Service", url: "#" },
    { id: "link-feasibility", label: "Financial Feasibility Brief", url: "#" }
  ]
};
